import React, { useContext, useState } from 'react';
import { AccountContext } from '../AccountContext';

export default function FeeTransaction() {
  const { accountId, feeService, setError } = useContext(AccountContext);
  const [feeCreating, setFeeCreating] = useState(false as boolean);
  const [amount, setAmount] = useState(0.0);
  const [feeName, setFeeName] = useState('');
  const [allowAmount, setAllowAmount] = useState(false);
  const [allowQuantity, setAllowQuantity] = useState(false);
  const [quantity, setQuantity] = useState(0);

  const setFeeFields = function (newFeeName) {
    setFeeName(newFeeName);
    const allAmount = newFeeName === 'Collection';
    setAllowAmount(allAmount);
    !allAmount && setAmount(0);
    const allQuantity = newFeeName === 'Statement';
    setAllowQuantity(allQuantity);
    allQuantity && setQuantity(0);
  };

  const onFeeClicked = async () => {
    try {
      setFeeCreating(true);
      await feeService.createFee(accountId, feeName, amount, quantity);
      setFeeCreating(false);
    } catch (error) {
      setFeeCreating(false);
      setError({ source: 'Fee', ...error });
    }
  };

  return (
    <div className="ui card">
      <div className="custom-card-header">Add Fee</div>
      <div className="content">
        <div className="ui form">
          <div className="field">
            <div className="ui labeled input">
              <div className="ui label">Type</div>
              <select onChange={(e) => setFeeFields(e.target.value)}>
                <option>Select</option>
                <option value="Trace">Trace Fee - £25</option>
                <option value="Collection">Collection Fee</option>
                <option value="ReturnedPayment">Returned Payment Fee - £12</option>
                <option value="Overlimit">Overlimit Fee - £12</option>
                <option value="LatePayment">Late Payment Fee - £12</option>
                <option value="Statement">Copy Statement Fee</option>
              </select>
            </div>
          </div>

          {allowAmount && (
            <div className="field">
              <label>Amount</label>
              <div className="ui labeled input">
                <div className="ui label">£</div>
                <input
                  type="number"
                  placeholder="Amount"
                  step=".01"
                  disabled={feeCreating}
                  onChange={(e) => setAmount(parseFloat(e.target.value))}
                />
              </div>
            </div>
          )}

          {allowQuantity && (
            <div className="field">
              <label>Quantity</label>
              <div className="ui labeled input">
                <div className="ui label">#</div>
                <input
                  type="number"
                  placeholder="Quantity"
                  step="1"
                  disabled={feeCreating}
                  onChange={(e) => setQuantity(parseInt(e.target.value))}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <button
        type="button"
        className={`ui primary button ${feeCreating && 'loading'}`}
        disabled={!feeName || (allowAmount && amount <= 0)}
        onClick={() => onFeeClicked()}>
        Charge Fee
      </button>
    </div>
  );
}
